import React, { FC } from 'react';
import { Flex } from 'antd';
import ImgLogo from '@/shared/pictures/fonbet_logo.png'
import { Link } from 'react-router-dom';

interface FonbetBannerProps{
  link: string
}

export const FonbetBanner:FC<FonbetBannerProps> = ({link}) => {
  if(!link) return;
  return (
    <Link className='fonbet-banner' to={link}>
      <Flex vertical gap={12}>
        <img className='fonbet-banner_logo' src={ImgLogo} alt="logo" />
        <p className='fonbet-banner_text'>Забирай фрибет <br/>и смотри Матчи Ови!</p>
      </Flex>
      <button type='button' className='fonbet-banner_button'>Забрать</button>
    </Link>
  )
};
